'use client'

import { useState } from 'react'
import { QuizFunnel } from '@/components/quiz'
import { HeroLandingB } from '@/components/landing/HeroLandingB'
import { LiquidGlassHeader } from '@/components/landing/LiquidGlassHeader'
import { AnimatePresence, motion } from 'framer-motion'

export default function Home() {
  const [showQuiz, setShowQuiz] = useState(false)

  return (
    <>
      {/* Header fora do AnimatePresence para evitar stacking context do Framer Motion */}
      {!showQuiz && <LiquidGlassHeader onStart={() => setShowQuiz(true)} />}

      <AnimatePresence mode="wait">
        {!showQuiz ? (
          <motion.div
            key="hero"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <HeroLandingB onStart={() => setShowQuiz(true)} />
          </motion.div>
        ) : (
          <motion.div
            key="quiz"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <QuizFunnel />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
